import { LocaleHome } from '../en/home'

const home: LocaleHome = {
  freePlayers: '所有玩家免费',
  ourPhilosophy: '我们的理念',
  innovateGame: '创新游戏',
  unifySport: '统一运动',
  theMostAccurateGlobal: '最准确的全球评级系统，受到世界顶级匹克球俱乐部、巡回赛和专业人士的信赖',
  optimizedAccuracy: '优化准确性',
  yourDUPRRating: '您的DUPR评分计算方式如下',
  marginVictory: '获胜方的分数额',
  pointsWon: '(赢得的分数）',
  typeResult: '结果类型',
  recreationalEtc: '(娱乐比赛与联赛、正式官方比赛等。)',
  outcome: '结果',
  winLoss: '(赢或输)',
  builtPickleball: '专为匹克球社区打造',
  builtPickleballDesc:
    '一个具有前瞻性思维和包容性的运动团体应该结合一个与之匹配的评级系统。有了DUPR，所有的选手，不管他们的年龄，性别，地理位置，或技能，都在2.00-8.00之间的同一尺度上被评分',
  whatWeDo: '我们做什么',
  aNewWayPlay: '一种新的玩法',
  aNewWayPlayDesc: 'DUPR评级系统不会丢失任何信息或数据。他们把一切都融入到他们的算法中，使它成为最精确的平台',
  searchTheDatabase: '搜索数据库',
  searchTheDatabaseDesc: '浏览超过1，000，000名匹克球选手的DUPR数据库。',
  findYourClub: '找到您的俱乐部',
  findYourClubDesc: '关注您的俱乐部，了解最新的赛事信息',
  analyzePerformance: '分析您的表现',
  analyzePerformanceDesc: 'DUPR在分析您的比赛表现来跟踪您的进展',
  logMatches: '比赛日志',
  logMatchesDesc: '随时输入每场比赛的分数。',
  connectLocalPlayers: '联系当地选手',
  connectLocalPlayersDesc: '找到本地选手并安排赛事。',
  events: '活动',
  eventsDesc: '在DUPR组织的赛事中，与实力相当的对手评测您的匹克球技术',
  pickleballGlobal: '匹克球最精确的全球评级系统',
  trustedByTheWorld: '深受世界顶级匹克球俱乐部、职业巡回赛和业余选手的信赖。',
}

export default home
